import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const Leadership = () => {
    const [expandedCard, setExpandedCard] = useState(null);

    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };

    const leaders = [
        {
            name: "Thiru M.K. Stalin",
            designation: "Hon'ble Chief Minister of Tamil Nadu",
            image: "/Images/cmlogo.png",
            hasImage: true,
            brief: "Hon'ble Chief Minister M.K. Stalin has been leading Tamil Nadu with a vision of inclusive growth and development. Under his leadership, the cooperative sector has witnessed significant reforms and modernization initiatives aimed at empowering rural communities and strengthening the cooperative movement in the state."
        },
        {
            name: "Thiru K. R. Periyakaruppan",
            designation: "Hon'ble Minister",
            department: "Cooperation, Food and Consumer Protection",
            image: "/Images/minister.png",
            hasImage: true,
            brief: "The Minister for Cooperation, Food and Consumer Protection oversees the implementation of policies that strengthen cooperative societies, ensure food security, and protect consumer rights across Tamil Nadu. The department works tirelessly to enhance the welfare of cooperative members and consumers."
        },
        {
            name: "Thiru Satyabrata Sahoo, IAS",
            designation: "Principal Secretary to Government",
            department: "Cooperation, Food and Consumer Protection Department",
            hasImage: false,
            brief: "As Principal Secretary, Satyabrata Sahoo IAS provides strategic direction to the Cooperation, Food and Consumer Protection Department. His administrative expertise ensures effective implementation of government schemes and policies that benefit cooperative societies and their members across Tamil Nadu."
        },
        {
            name: "Thiru K. Nanthakumar, IAS",
            designation: "Registrar of Cooperative Societies",
            department: "Tamil Nadu",
            hasImage: false,
            brief: "K. Nanthakumar IAS, as the Registrar of Cooperative Societies, plays a pivotal role in regulating and promoting cooperative societies in Tamil Nadu. He oversees registration, auditing, and dispute resolution while fostering the growth and sustainability of the cooperative movement in the state."
        }
    ];

    return (
        <div style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
            
            {/* Leadership Section with Custom Grey Background */}
            <section className="py-8" style={{ backgroundColor: '#f2f2f2' }}>
                <div className="container mx-auto px-4">
                    {/* Header */}
                    <div className="text-center mb-6">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
                            Leadership
                        </h2>
                        <div className="w-20 h-1 bg-gray-800 mx-auto"></div>
                    </div>

                    {/* Leadership Cards */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-7xl mx-auto ">
                        {leaders.map((leader, index) => (
                            <div 
                                key={index}
            className="shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer border border-gray-300 overflow-hidden"
                                onClick={() => toggleCard(index)}
                            >
                                {/* Card Header */}
                      <div className="bg-gradient-to-r from-[#005A8D] to-[#006AA5] p-4 min-h-[110px]">
    <div className="flex items-center gap-4">

        {/* Image Section */}
        {leader.hasImage === true && (
            <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-white rounded-full overflow-hidden flex items-center justify-center shadow-lg">
                    <img
                        src={leader.image}
                        alt={leader.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML =
                                '<div class="w-8 h-8 text-[#005A8D]"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></div>';
                        }}
                    />
                </div>
            </div>
        )}

        {/* Details Section */}
        <div className="flex-grow min-h-0">
            <h3 className="text-lg font-bold text-white leading-tight">{leader.name}</h3>
            <p className="text-sm font-semibold text-white/90 uppercase tracking-wide leading-tight mt-1">
                {leader.designation}
            </p>
            {leader.department && (
                <p className="text-sm text-white/80 leading-tight mt-1">
                    {leader.department}
                </p>
            )}
        </div>

        {/* Expand Icon */}
        <div className="flex-shrink-0">
            <div className="w-8 h-8 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                {expandedCard === index ? (
                    <ChevronUp className="w-5 h-5 text-white" />
                ) : (
                    <ChevronDown className="w-5 h-5 text-white" />
                )}
            </div>
        </div>
    </div>
</div>


                                {/* Expandable Brief */}
                                {expandedCard === index && (
                                    <div className="p-4 bg-gray-50 border-t border-gray-200">
                                        <p className="text-sm text-gray-700 leading-relaxed">
                                            {leader.brief}
                                        </p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Leadership;